import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { FormDialogTemplate } from "../../../../shared/form-dialog/form-dialog.template";
import { FilterableService } from "../../../../../../src/app/components/mesc/filterable-service";
import { BaseService } from "../../../../../../src/app/components/mesc/mesc.service";

@Injectable()
export class PartListService {
    public dialogStack: FormDialogTemplate[] = [];
    selectedProgram: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    selectedPlant: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    selectedPress: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    selectedPart: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    isShowOptimization: Subject<boolean> = new BehaviorSubject<boolean>(false)
    selectedPartDetail: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    partCode: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    toolsetId: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    pressClass: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    partType: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    formDialog: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    filterChanged: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    isCollapsed: boolean;
    resetting = false;
    tabIndex = 0;
    
    lookupData = {
        ContainerSourceViewDto: new FilterableService(),
        ContainerTypeViewDto: new FilterableService(),
        DieFamilyViewDto: new FilterableService(),
        DieSourceViewDto: new FilterableService(),
        MaterialViewDto: new FilterableService(),
        PartTypeViewDto: new FilterableService(),
        PlantViewDto: new FilterableService(),
        PressViewDto: new FilterableService(),
        ProgramViewDto: new FilterableService(),
        SideViewDto: new FilterableService(),
        ToolSetViewDto: new FilterableService()
    };
    
    constructor(private readonly baseService: BaseService) {
        this.baseService.read('phf/Part/PartLookup')
        .then(x => {
            Object.keys(x)
            .forEach(k => {
                this.lookupData[k].next(x[k]);
            });
        });
        this.selectedProgram
        .subscribe(x => this.filterChanged.next(null))
        this.selectedPlant
        .subscribe(x => {
            if (!this.selectedPress.value) this.filterChanged.next(null);
        })
        this.selectedPress
        .subscribe(x => this.filterChanged.next(null))
        this.partCode
        .subscribe(x => this.filterChanged.next(null))
        this.toolsetId
        .subscribe(x => this.filterChanged.next(null))
        this.partType
        .subscribe(x => this.filterChanged.next(null))
    }
    
    openDialog(template: FormDialogTemplate) {
        if (template) this.dialogStack.push(template);
        this.formDialog.next(template);
    }
    
    closeDialog() {
        this.dialogStack.pop();
        this.openDialog(this.dialogStack.pop());
    }
    
    
    /**
    * Returns filters selected in Search Sidebar
    */
    getSearchFilters() {
        const _filters = {};
        if (this.selectedProgram.value) {
            _filters['ProgramCode'] = [this.selectedProgram.value.Code, this.isDirectComparison(this.selectedProgram.value.Code)];
        }
        if (this.selectedPlant.value) {
            _filters['PlantName'] = [this.selectedPlant.value.Name, this.isDirectComparison(this.selectedPlant.value.Name)];
        }
        if (this.selectedPress.value) {
            _filters['PlantName'] = [this.selectedPress.value.PlantName, this.isDirectComparison(this.selectedPress.value.PlantName)];
            _filters['PressNumber'] = [this.selectedPress.value.Number, this.isDirectComparison(this.selectedPress.value.Number)];
        }
        if (this.partCode.value) {
            _filters['Code'] = [this.partCode.value, this.isDirectComparison(this.partCode.value)];
        }
        if (this.toolsetId.value) {
            _filters['ToolSetCode'] = [this.toolsetId.value.Code, this.isDirectComparison(this.toolsetId.value.Code)];
        }
        if (this.partType.value) {
            _filters['PartType'] = [this.partType.value.Description, this.isDirectComparison(this.partType.value.Description)];
        }
        return _filters;
    }
    
    resetFilters() {
        this.resetting = true;
        this.partCode.next(null);
        this.toolsetId.next(null);
        this.resetting = false;
        this.partType.next(null);
    }
    
    isDirectComparison(dataItem: any): string {
        if(dataItem) return "true";
        return "false";
    }
}
